import { createSlice } from "@reduxjs/toolkit";
import {
  loginUser,
  signupUser,
  googleLogin,
  forgetPassword,
  verifyOTP,
  resendOTP,
  resetPassword,
  AddPhoneNumber,
  changePassword,
} from "./thunk";
import { toast } from "react-toastify";
import i18n from "../../../i18n";
const storedUser = localStorage.getItem("authUser");
const parsedUser = storedUser ? JSON.parse(storedUser) : null;

const initialState = {
  user: parsedUser?.data || null,
  token: parsedUser?.data?.token || null,
  loading: false,
  error: null,
};

const handleRejected = (state, action, defaultMessage) => {
  // console.log("Handling rejected action:", action);
  state.loading = false;
  state.error = action.payload?.error?.message;
  state.error || i18n.t(defaultMessage) || i18n.t("common.somethingWrong");
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      localStorage.removeItem("authUser");
    },
  },
  extraReducers: (builder) => {
    builder
      // LOGIN
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.data;
        state.token = action.payload.data.token;
        state.error = null;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Login failed";
      })

      // SIGNUP
      .addCase(signupUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(signupUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.data;
        state.token = action.payload.data.token;
        state.error = null;
      })
      .addCase(signupUser.rejected, (state, action) => {
        state.loading = false;
        // console.log(action.payload);
        state.error = action.payload || "Signup failed";
      })

      // GOOGLE LOGIN
      .addCase(googleLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(googleLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload.data;
        state.token = action.payload.data.token;
        state.error = null;
      })
      .addCase(googleLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Google login failed";
      })
      //  FORGET PASSWORD
      .addCase(forgetPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(forgetPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(forgetPassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Forget Password failed";
      })
      // VERIFY OTP
      .addCase(verifyOTP.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyOTP.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(verifyOTP.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "OTP verification failed";
      });

    // RESEND OTP
    builder
      .addCase(resendOTP.pending, (state) => {
        state.resendLoading = true;
        state.error = null;
      })
      .addCase(resendOTP.fulfilled, (state, action) => {
        state.resendLoading = false;
        state.message = action.payload.message || "OTP Resent Successfully";
        toast.success(i18n.t("authSlice.otp.resendSuccess"));
      })
      .addCase(resendOTP.rejected, (state, action) => {
        state.resendLoading = false;
        state.error = action.payload;
        // toast.error(`${action.payload}`);
      });

    //  RESET PASSWORD
    builder
      .addCase(resetPassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        // console.log(action.payload);
        toast.success(i18n.t("authSlice.password.resetSuccess"));
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.loading = false;
        // toast.error(`${action.payload}`);
      })
      // 🟢 Change Password
      .addCase(changePassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changePassword.fulfilled, (state, action) => {
        state.loading = false;
        // state.companies.push(action.payload);
        toast.success(i18n.t("authSlice.password.changeSuccess"));
      })
      .addCase(changePassword.rejected, (state, action) => {
        // console.log("Change Password rejected action:", action);
        handleRejected(state, action, "Error Password Change failed");
      });

    // Add Phone Number
    builder.addCase(AddPhoneNumber.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(AddPhoneNumber.fulfilled, (state, action) => {
      state.loading = false;
      state.successMessage = "Address created successfully!";
      // state.addresses.push(action.payload);
    });
    builder.addCase(AddPhoneNumber.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
